module.exports = "<div class=\"session\">\n\t<page-spinner v-show=\"loading\"></page-spinner>\n\t<router-view></router-view>\n</div>\n"